<template>
	<div class="home">
		<Header ref="header" :type='headType'></Header>
		<BanIn url="image004">
			<template v-slot:text>
				<h2 class="inTit f48 wow fadeInLeft">新闻资讯</h2>
				<div class="inDes f24 wow fadeInRight">
					<p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
				</div>
			</template>
		</BanIn>
        <div class="mainBg">
			<div class="newsBg">
				<div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">新闻资讯</h2>
                    </div>
                    <ul class="sortList wow fadeInUp" id="anchor">						
                        <li :class="{active:type ==''}"><router-link to="/news">全部</router-link></li>
						<li v-for="(item, index) in newsType" :key="index" :class="type == item[0] ? 'active' : '' "><router-link :to="'/news?type='+ item[0]">{{ item[1] }}</router-link></li>
                    </ul>
					<div class="newsTop flex justify-between" v-if="page == 1">
						<div class="newsLeft wow fadeInLeft" v-if="newsList.length">
							<router-link class="newsLink" :to="'/newsDetail?id='+ newsList[0].id">
								<div class="newsImg baseImg">
									<img :src="newsList[0].image" alt="">
								</div>
								<h3 class="newsTit f18 color3 MultiLine">{{newsList[0].title}}</h3>
								<div class="newsDate f18 color9">{{newsList[0].article_date}}</div>
							</router-link>
						</div>
						<div class="newsRight" v-if="newsList.length > 1">                
							<ul class="newsList list-style flex flex-wrap justify-between">
								<li class="wow fadeInUp" v-for="(item, index) in topList" :key="index">
									<router-link class="newsLink" :to="'/newsDetail?id='+ item.id">
										<div class="newsTime f20 color_m">
											<div>
												<strong class="f60">{{item.article_date.substring(8,10)}}</strong>
												<p>{{item.article_date.substring(0,7)}}</p>
											</div>
										</div>
										<div class="newsItem">
											<h3 class="newsTit f18 color3 MultiLine">{{item.title}}</h3>
											<div class="newsCon f16 color6 MultiLine">
												<div class="newsDes" v-html="item.content_short"></div>
											</div>
										</div>
									</router-link>
								</li>
							</ul>
						</div>
					</div>
					<ul class="newsList list-style flex flex-wrap justify-between" v-if="newsList.length">
						<li v-for="(item, index) in list" :key="index">
							<router-link class="newsLink" :to="'/newsDetail?id=' + item.id">
								<div class="newsTime f20 color_m">
									<div>
										<strong class="f60">{{item.article_date.substring(8,10)}}</strong>
										<p>{{item.article_date.substring(0,7)}}</p>
									</div>
								</div>
								<div class="newsItem">
									<h3 class="newsTit f18 color3 MultiLine">{{item.title}}</h3>
									<div class="newsCon f16 color6 MultiLine">
										<div class="newsDes" v-html="item.content_short"></div>
									</div>
								</div>
							</router-link>
						</li>
					</ul>
					<el-empty v-else description="暂无内容"></el-empty>
					<el-pagination
						:page-size="size"
						:pager-count="5"
						layout="prev, pager, next"
						:total="total"
						@current-change="getpage"
						v-if="newsList.length"
					>
					</el-pagination>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import BanIn from '@/components/BanIn.vue'
	import Footer from '@/components/Footer.vue'
	import { WOW } from 'wowjs'
	import home from '../api/home'
	export default {
		name: 'Case',
		components: {
			Header,
			BanIn,
			Footer
		},
		data() {
			return {
				headType:3,
				type:'',
				newsType:[],
				page:1,
				size:10,
				newsList:[],
				list:[],
				topList: [],
				total:0,
			}
		},
		watch: {
			'$route' () {
				this.type = this.$route.query.type || '';
				this.page = 1;
				this.size = 10;
				this.getlist();
			}
		},
		mounted() {
			this.$nextTick(()=>{
				new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
				
				// // 动态内容加载完成后调用 sync 方法，确保在每次动态加载内容后调用 this.$wow.sync() 方法，以便 WOW.js 能够重新扫描页面并为新的 wow 元素添加动画（没起作用）
				// this.$nextTick(() => {
				//   this.$wow.sync();
				// });
			});
			this.type = this.$route.query.type || '';
			this.getlist();
		},
		methods:{
			getlist(){
				home.newsList({page:this.page,limit:this.size,t:this.type}).then((res)=>{
					if (res.code === 1) {
						this.newsType = res.data.article?Object.entries(res.data.article):'';
						this.newsList = res.data.rows;
						this.total = res.data.total;
					} else {
						this.$toast(res.msg)
					}
					// 如果是第一页的话
					if(this.page == 1){
						this.topList =  this.newsList.filter((element, index) => index >= 1 && index <= 3);
						this.list = this.newsList.filter((element, index) => index >= 4);
					}else{
						this.list = this.newsList
					}
				});
			},
			getpage(e){
				window.scrollTo(0,0);
				this.page = e;
				this.getlist();
			},
		}
		
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/news.scss';
</style>